<template>
  <div>
    <SpFilterForm :model="formData" @onSearch="onSearch" @onReset="onReset">
      <SpFilterFormItem prop="coupon_no">
        <el-input v-model="formData.coupon_no" placeholder="请输入券code" />
      </SpFilterFormItem>
      <SpFilterFormItem prop="coupon_name">
        <el-input v-model="formData.coupon_name" placeholder="请输入券名称" />
      </SpFilterFormItem>
      <SpFilterFormItem prop="limit_goods_type">
        <el-select v-model="formData.limit_goods_type" placeholder="请选择商品适用范围">
          <el-option v-for="item in goodOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </SpFilterFormItem>
      <SpFilterFormItem prop="limit_shop_type">
        <el-select v-model="formData.limit_shop_type" placeholder="请选择店铺适用范围">
          <el-option v-for="item in shopOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </SpFilterFormItem>
    </SpFilterForm>

    <el-tabs v-model="formData.coupon_type" @tab-click="handleClick">
      <el-tab-pane v-for="item in tabsList" :key="item.name" :label="item.label" :name="item.name"></el-tab-pane>
    </el-tabs>

    <SpFinder no-selection ref="finder" :setting="setting" row-actions-width="200" :row-actions-align="'left'"
      :fixed-row-action="true" :url="url" :split-count="4" :hooks="{ beforeSearch: beforeSearch }" />

  </div>
</template>

<script>
const COUPON_TYPE = {
  'full_minus': {
    label: '满减',
    name: 'full_minus'
  },
  'repeat_full_minus': {
    label: '每满减',
    name: 'repeat_full_minus'
  },
  'full_discount_price': {
    label: '满金额折扣',
    name: 'full_discount_price'
  },
  'fill_discount_num': {
    label: '满件数折扣',
    name: 'fill_discount_num'
  }
}

import Vue from 'vue'
import { createSetting, useDialog } from '@shopex/finder'
import ImportDialog from '@/components/importDialog'

export default {
  data() {
    return {
      goodOptions: [
        {
          value: 'none',
          label: '不限制'
        },
        {
          value: 'in',
          label: '包含'
        },
        {
          value: 'not_in',
          label: '排除'
        },
      ],
      shopOptions: [
        {
          value: 'shop',
          label: '限制门店'
        },
        {
          value: 'all',
          label: '不限制'
        },
      ],
      tabsList: [
        {
          label: '全部',
          name: '0'
        },
        ...Object.values(COUPON_TYPE)
      ],
      formData: {
        coupon_no: '',
        coupon_name: '',
        coupon_type: '0',
        limit_goods_type: '',
        limit_shop_type: ''
      },
    }
  },
  computed: {
    url() {
      return `/discountcard/crm/list`
    },
    setting() {
      return createSetting({
        columns: [
          { name: '券Code', key: 'coupon_no' },
          {
            name: '券类型', key: 'coupon_type',
            render: (h, { row }) => {
              return (
                <div>{COUPON_TYPE[row.coupon_type].label}</div>
              )
            }
          },
          {
            name: '券信息', key: 'coupon_describe',
            render: (h, { row }) => {
              return (
                <div>
                  <div style='color: #176721;'>{row.coupon_name}</div>
                  <div>{row.coupon_describe}</div>
                </div>
              )
            }
          },
          {
            name: '使用门槛', key: 'conditions',
            render: (h, { row }) => {
              return (
                <div style='color: #176721;'>{this.conditionsText(row)}</div>
              )
            }
          },
          {
            name: '抵扣', key: 'rewards',
            render: (h, { row }) => {
              return (
                <div style='color: #176721;'>{this.rewardsText(row)}</div>
              )
            }
          },
          {
            name: '是否可叠加使用', key: 'overlay_use',
            render: (h, { row }) => {
              return (
                <div style='color: #176721;'>{row.overlay_use == '1' ? '是' : '否'}</div>
              )
            }
          },
          {
            name: '成本来源', key: 'cost_source',
            render: (h, { row }) => {
              return (
                <div style='color: #176721;'>{row.cost_source == 'platform' ? '平台' : '经销商'}</div>
              )
            }
          },
          {
            name: '是否是积分券', key: 'coupon_category',
            render: (h, { row }) => {
              return (
                <div style='color: #176721;'>{row.coupon_category == 'point' ? '是' : '否'}</div>
              )
            }
          },
          {
            name: '限用张数', key: 'use_quantity_limit',
            render: (h, { row }) => {
              return (
                <div style='color: #176721;'>{row.use_quantity_limit}</div>
              )
            }
          },
          {
            name: '适用范围', key: 'item_name',
            render: (h, { row }) => {
              return (
                <div>
                  <span style='color: #176721;margin-right: 10px'>
                    {row.limit_goods_type == 'none' ? '不限制商品' : row.limit_goods_type == 'in' ? '包含商品' : '排除商品'}
                  </span>
                  <span style='color: #176721;'>{row.limit_shop_type == 'all' ? '不限制店铺' : row.limit_shop_type == 'shop' ? '店铺' : '经销商'}</span>
                </div>
              )
            }
          },
          {
            name: '操作',
            key: '',
            width: 350,
            render: (h, {row}) => {
              return (
                <div>
                  <el-button type='text' size="small" on-click={() => this.showShopList(row)}>查看适用门店</el-button>
                  <el-button type='text' size="small" on-click={() => this.showGoodsList(row, 'crm')}>查看CRM商品</el-button>
                  <el-button type='text' size="small" on-click={() => this.showGoodsList(row, 'wxapp')}>查看小程序商品</el-button>
                  {row.upload_item && (
                    <ImportDialog
                      buttonName='导入商品'
                      buttonSize='small'
                      fileName='导入商品'
                      buttonType='text'
                      fileType='upload_crm_coupon_item'
                      relId={row.coupon_no}
                    />
                  )}

                  <ImportDialog
                    buttonName="导入小程序显示商品"
                    fileName="导入小程序显示商品"
                    fileType="detail_display_items"
                    buttonType="text"
                    relId={row.coupon_no}
                    customParams={{ rel_source: 'crm' }}
                    buttonSize="small"
                    >
                  </ImportDialog>
                </div>
              )
            }
          }
        ]
      })
    },
  },
  methods: {
    onSearch() {
      this.$refs.finder.refresh(true)
    },
    onReset() {
      this.formData = {
        coupon_no: '',
        coupon_name: '',
        coupon_type: '0',
        limit_goods_type: '',
        limit_shop_type: ''
      }
      this.onSearch()
    },
    beforeSearch(param) {
      let params = {
        ...this.formData,
        ...param,
      }
      if (params.coupon_type === '0') {
        delete params.coupon_type
      }
      return params
    },
    handleClick(tab, event) {
      this.onSearch()
    },
    conditionsText(row) {
      const textMap = {
        repeat_full_minus: `每满${row.conditions / 100}元`,
        fill_discount_num: `满${row.conditions}件`,
      };
      return textMap[row.coupon_type] || `满${row.conditions / 100}元`;
    },
    rewardsText(row) {
      return row.coupon_type === 'full_discount_price' || row.coupon_type === 'fill_discount_num'
        ? `满${row.rewards}折`
        : `满${row.rewards / 100}元`;
    },
    showShopList (row) {
      useDialog(null, {
        no: row.coupon_no,
        title: `查看适用门店`,
        width: '50%',
        component: () => import('./comps/crm-shop-list.vue'),
      })
    },
    showGoodsList (row, type) {
      useDialog(null, {
        no: row.coupon_no,
        title: `查看商品列表`,
        width: '50%',
        add_source: type,
        component: () => import('./comps/crm-goods-list.vue'),
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.item_name {
  color: #409EFF;
}
</style>
